import { uploadBlogPdf } from "../api/blogs";
import { blogPdfFileName } from "./blogPdf";

/**
 * Uploads each in-editor PDF placeholder and replaces it with a real `oa-pdf-embed` path.
 * Mutates `filesById` (Map): deletes entries for uploaded ids.
 * @param {string} html
 * @param {Map<string, File>} filesById
 * @returns {Promise<string>}
 */
export async function flushPendingPdfsInHtml(html, filesById) {
    const raw = typeof html === "string" ? html : "";
    if (!raw.includes("oa-pdf-pending") && !raw.includes("data-pdf-pending-id")) {
        return raw;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div class="oa-flush-root">${raw}</div>`, "text/html");
    const root = doc.querySelector(".oa-flush-root");
    if (!root) return raw;

    const nodes = [...root.querySelectorAll(".oa-pdf-pending[data-pdf-pending-id]")];
    for (const el of nodes) {
        const id = el.getAttribute("data-pdf-pending-id");
        if (!id) {
            el.remove();
            continue;
        }
        const file = filesById.get(id);
        if (!file) {
            const label = el.getAttribute("data-pdf-label") || id;
            throw new Error(
                `A PDF in the article is missing its file (“${label}”). Remove that line or insert the PDF again, then save.`
            );
        }
        const { pdfUrl } = await uploadBlogPdf(file);
        if (!pdfUrl || typeof pdfUrl !== "string" || !pdfUrl.startsWith("/uploads/blog-pdfs/")) {
            throw new Error("The server returned an invalid path after uploading a PDF.");
        }
        const repl = doc.createElement("div");
        repl.setAttribute("class", "oa-pdf-embed");
        repl.setAttribute("data-pdf-url", pdfUrl);
        repl.setAttribute("data-pdf-label", blogPdfFileName(pdfUrl));
        repl.setAttribute("contenteditable", "false");
        el.replaceWith(repl);
        filesById.delete(id);
    }

    return root.innerHTML;
}
